import Loadable from 'react-loadable';
import loading from '../components/common/FullPageSpinner/FullPageSpinner';
export default (function (loader) {
  return Loadable({
    loader: loader,
    loading: loading,
    delay: 300
  });
});